module.exports = {
  pleaseWait: 'Mohon tunggu',
  loading: 'Memuat...',
  Billing: 'Tagihan',
  billingTips: 'Riwayat Pembelian Anda',
  ID: 'ID',
  FAQ: 'Pertanyaan Umum',
  TC: 'Syarat & Ketentuan',
  Copyright: '© 2026 Hak Cipta Dilindungi.',
  GenerateImage: 'Buat Gambar',
  generateTips1: 'Generator gambar AI kami menghidupkan imajinasi Anda, menghasilkan seni, ilustrasi, dan foto memukau dalam hitungan detik. Salurkan kreativitas dan ekspresikan diri Anda dengan cara baru melalui kekuatan AI. Jelajahi berbagai kemungkinan, mulai dari membuat materi pemasaran yang unik hingga karya seni yang indah, semuanya dengan sangat mudah dan cepat.',
  generateTips2: 'Ketik beberapa kata di bawah ini, lalu lihat Snapai mengubah teks Anda menjadi karya seni yang luar biasa.',
  Prompt: 'Petunjuk Teks',
  PromptTips1: 'Beri tahu AI apa yang ingin Anda gambar.',
  PromptTips2: 'Tips: Jelaskan suasana dan pencahayaannya. Lihat tips halaman untuk informasi lebih lanjut.',
  PromptTips3: 'Catatan: AI mungkin tidak selalu mengikuti petunjuk dan tidak bisa menghitung.',
  Generate: 'Buat',
  ChancesLeft: 'Sisa Kesempatan',
  BuyChances: 'Beli Kesempatan Lagi',
  generateImageTips1: 'Masukkan hal yang ingin Anda tampilkan',
  generatePromptsTips1: 'Masukkan hal yang TIDAK ingin Anda tampilkan',
  indexTips1: 'Kesempatan Gratis Harian <br /> Tersedia!',
  indexTips2: 'Pilih salah satu di bawah ini',
  ImageRestorer: 'Perbaiki Foto',
  Continue: 'Lanjutkan',
  language0: 'Bahasa',
  language: 'Pilih Bahasa',
  languageTips: 'Pilih bahasa Anda di sini',
  Submit: 'Kirim',
  change: 'Ubah',
  English: 'English',
  Myanmar: 'Indonesia',
  Login: 'Masuk',
  Logout: 'Keluar',
  getCode: 'Kirim Kode',
  loginTips: 'Masukkan nomor telepon',
  profile: 'Profil',
  phoneNumber: 'Nomor Telepon',
  SubscribedSince: 'Berlangganan sejak',
  RemainingChances: 'Sisa kesempatan',
  cgtips2: 'Hanya 149ks/hari,<br />silakan klik OK untuk berlangganan.',
  cgtips2W: 'Hanya 599ks/minggu,<br />silakan klik OK untuk berlangganan.',
  cgtips2M: 'Hanya 1999ks/bulan,<br />silakan klik OK untuk berlangganan.',
  OK: 'OK',
  PictureRestorer: 'Perbaiki Gambar',
  PictureTips1: 'Pulihkan, pertajam, dan perbaiki foto menggunakan AI. Snapai memanfaatkan teknologi terbaru untuk menghapus goresan secara otomatis, memperjelas warna, dan memperindah wajah—mengubah foto lama yang rusak menjadi kenangan berharga. Layanan gratis kami dapat memperbaiki foto berwarna maupun hitam putih.',
  Upload: 'Unggah',
  PictureTips2: 'Ada Goresan?',
  Restore: 'Pulihkan',
  uploadTips: 'Silakan unggah foto',
  PurchaseChances: 'Beli Kesempatan',
  History: 'Riwayat',
  purchaseTips1: 'Total kesempatan Anda',
  purchaseTips2: 'Pembelian Sekali Pakai',
  Daily: 'Harian',
  Weekly: 'Mingguan',
  OneTime: 'Sekali Beli',
  Purchase: 'Beli',
  DailyKyats: '169 Kyats',
  WeeklyKyats: '699 Kyats',
  OneTimeChance: '149 Ks/Kesempatan',
  Subscribe: 'Berlangganan',
  purchaseTips3: 'Pilih berapa banyak <strong>KESEMPATAN</strong> yang ingin dibeli.',
  BuyNow: 'Beli Sekarang',
  logout: 'Keluar',
  petTitle1: 'Anime Hewan Peliharaan AI',
  petTitle2: 'Pilih Gaya',
  petContent1: 'mengubah foto hewan kesayangan Anda menjadi karya seni bergaya anime yang lucu. Sangat cocok untuk pecinta hewan dan penggemar anime, Snapai menghadirkan cara seru untuk merayakan hewan peliharaan Anda.',
  sexTitle1: 'Anime Diri AI',
  sexTitle2: 'Pilih Jenis Kelamin',
  sexContent1: 'Menghidupkan imajinasi Anda dengan membuat foto bergaya anime berdasarkan deskripsi teks. Baik Anda penggemar anime, penulis cerita, atau desainer, AI Anime Photo memudahkan Anda membuat visual gaya anime yang keren dan berkualitas tinggi.',
  sexContent2: 'Pilih jenis kelamin dan masukkan deskripsi di bawah. Lihat Snapai mengubah teks menjadi gambar luar biasa.',
  Female: 'Wanita',
  Male: 'Pria',
  Style1: 'Gaya 1',
  Style2: 'Gaya 2',
  Style3: 'Gaya 3',
  Comic: 'Komik',
  Disney: 'Disney',
  Ghibli: 'Ghibli',
  Animalanime: 'Anime Swafoto',
  HumanAnime: 'Anime Manusia',
  Guidance: 'Panduan',
  PetAnime: 'Anime Hewan',
  landTips1: 'Buat Foto Memukau &',
  landTips2: 'MENANGKAN HADIAH BESAR!',
  landTips3: 'Ubah imajinasi Anda menjadi kenyataan bersama SnapAI! Dari pembuatan foto indah hingga karya seni memukau, SnapAI membantu Anda membuat visual yang belum pernah ada sebelumnya.',
  show401tip: 'Saldo tidak cukup',
  show400dailytip: 'Waktu habis, silakan kirim "ON1" ke 548 untuk memenangkan hadiah besar.',
  show400weeklytip: 'Waktu habis, silakan kirim "ON7" ke 548 untuk memenangkan hadiah besar.',
  register: 'Daftar',
  invitation: 'Undangan',
  invitationTips: 'Salin dan kirim undangan menggunakan tautan di bawah ini',
  InviteNow: 'Undang Sekarang',
  copySuccess: 'Berhasil Disalin!',
  process: 'Sedang Memproses...',
  downTips1: 'Silakan salin tautan ke peramban (browser) untuk mengunduh.',
  copyLink: 'Salin tautan',
  free: 'Gratis',
  aiAnimeTitle: 'Anime Pasangan AI',
  aiAnimeCt1: 'Ubah foto pasangan Anda menjadi gambar bergaya anime agar kenangan romantis jadi lebih seru. Buat visual romantis berkualitas tinggi dengan mudah menggunakan teknologi AI.',
  aiAnimeCt2: 'Pilih gaya di bawah dan unggah foto Anda untuk melihat Snapai mengubah kenangan manis Anda menjadi karya seni yang indah.',
  comingsoonT: 'Segera Hadir',
  SubscribePackage: 'Paket Berlangganan',
  landfont1: 'Ubah foto menjadi karya seni anime yang keren.',
  landfont2: 'Ubah foto pasangan menjadi karakter anime yang indah.',
  landfont3: 'Tulis petunjuk teks untuk menghasilkan gambar cantik.',
  landfont4: 'Ubah hewan peliharaan Anda jadi karakter anime menggemaskan dengan keajaiban AI!',
  landfont5: 'Temukan kembali kenangan lama Anda dengan pemulihan foto berbasis AI.',
  SmartCutout: 'Hapus Latar Otomatis',
  letgo: 'Mulai Sekarang',
  IpIMage: 'Foto Pasfoto (ID)',
  IpIMageTip: 'Butuh foto untuk SIM atau Kartu Identitas? Kami siap membantu!',
  IpIMage_content: 'Foto asli yang diunggah untuk pasfoto harus menampilkan wajah dengan jelas tanpa halangan, serta posisi bahu rata. Jika tidak, proses pembuatan bisa gagal.',
  snapbot: 'SnapBot',
  snapbot_hi: 'Halo, saya SnapBot.',
  help_today: 'Ada yang bisa saya bantu hari ini?',
  think_ip: '🤖 Sedang berpikir...',
  Coloring_old_photos: 'Warnai Foto Hitam Putih',
  Coloring_old_photos_tips: 'Hidupkan kembali kenangan Anda dengan memberi warna pada foto-foto lama. Alat berbasis AI kami secara otomatis menganalisis dan menambahkan warna alami tanpa menghilangkan kesan aslinya.',
  Coloring_old_photos_tips2: 'Hidupkan foto jadul Anda dengan pemulihan warna berbasis AI.',
  BgFusion: 'Ganti Latar Cerdas',
  BgFusion_tips2: 'Ubah latar belakang foto sesuai keinginan Anda',
  BgFusion_tips: 'Ubah latar belakang foto sesuai keinginan Anda. AI cerdas kami akan mengganti latar asli dan menyatukan foto Anda secara alami ke dalam pemandangan baru.',
  Upload_bg: 'Unggah Latar Belakang',
  Upload_pt: 'Unggah Foto Orang',
  Recolor: 'Warnai Ulang',
  snapbotTips1: 'Pencarian Hasil Cepat',
  snapbotTips2: 'Pemrosesan Bahasa Alami',
  snapbotTips3: 'Analisis Data Besar',
  snapbotTips4: 'Algoritma Cerdas AI',
  snapbotInput1: 'Ketuk di sini untuk mulai mengobrol dengan SnapBot',
  white: 'putih',
  blue: 'biru',
  '1 inch': '1 inci',
  '2 inches': '2 inci',
  '3 inches': '3 inci',
  landTips11: 'Buat Foto Keren &',
  ChangeHairstyle: 'Ubah Gaya Rambut',
  ChangeHairstyle_short: 'Coba berbagai gaya rambut impian Anda',
  ChangeHairstyle_content_1: 'Aplikasi SnapAI menyediakan fitur ganti gaya rambut yang memungkinkan Anda mencoba potongan rambut berbeda secara langsung atau via foto. AI akan menganalisis bentuk wajah Anda dan menyarankan gaya rambut yang cocok.',
  ChangeHairstyle_content_2: 'Pilih gaya rambut favorit Anda di bawah ini dan unggah foto Anda untuk mendapatkan hasil yang bagus dan jelas.',
  Result: 'Hasil',
  Original: 'Foto Asli',
  unsub_tip: 'Untuk berhenti berlangganan, kirim OFF ke 548',
  sub_tip: 'Untuk berlangganan, kirim "ON1" atau "ON7" ke 548',
  longHairEffects: 'Efek Rambut Panjang',
  longHairEffects_tip: 'Coba Efek Rambut Panjang untuk tampilan yang alami dan menarik. Rapi & berkilau, Panjang alami, Cocok untuk gaya pakaian apa pun!',
  VIDEO: 'VIDEO',
  image_video: 'Foto Jadi Video',
  image_video_tip: 'Fitur ini mengubah foto diam menjadi video animasi berdurasi 1–3 menit, menambahkan ekspresi wajah dan gerakan alami.',
  word_video: 'Teks Jadi Video',
  word_video_tip: 'Fitur ini mengubah teks tulisan Anda menjadi video dinamis nyata menggunakan teknologi AI. Proses pembuatan memakan waktu 1–3 menit.',
  word_video_input: "Jelaskan gaya dan tampilan video yang ingin Anda buat.",
  image_video_input: "Jelaskan gaya dan tampilan foto yang ingin Anda buat.",
  aiDressUp: "Ganti Pakaian AI",
  aiDressUp_tip: "Dengan AI Dress Up, ubah penampilan Anda seketika! Unggah foto Anda dan coba berbagai macam pakaian—tradisional, formal, atau santai.",
  singleheart: "Efek Tanda Cinta",
  singleheart_desc: "Bagikan kasih sayang Anda! Tambahkan efek bentuk hati yang manis dan romantis ke video Anda.",
  aiVividScene: "Latar Suasana AI",
  aiVividScene_desc: "Hanya dengan satu foto wajah yang jelas, Anda bisa memilih berbagai Latar Belakang, Gaya, dan Nada Warna untuk menghasilkan foto keren.",
  pic_size_limit: "Ukuran gambar tidak boleh lebih dari 5MB",
  spin_tip_1: "Jangan lewatkan kesempatan Anda!",
  spin_tip_2: "Roda putar keberuntungan hanya tersedia di misi harian",
  close: "Tutup",
  spin: 'Putar',
  SpinChances: 'Kesempatan Putar',
  date: 'Tanggal',
  Prizes: 'Hadiah',
  nochance: 'Kesempatan Anda tidak cukup',
  WinnerList: 'Daftar Pemenang',
  Congratulations: "Selamat! Anda menang",
  Confirm: "Konfirmasi",
  spinTips2: 'Putaran Gratis Harian!',
  spinTips3: 'Klaim Token Putaran Keberuntungan GRATIS Anda hari ini!',
  spinTips4: 'Ambil Token Saya',
  No: 'Tidak',
  not_win: "Terima kasih sudah bermain. Coba lagi lain kali!",
  win_tip: 'Ketuk di bawah untuk mengambil hadiah Anda',
  Trending: 'Populer',
  Face_Magic: 'Sihir Wajah',
  AI_Studio: 'AI Studio',
  Home: 'Beranda',
  unsubscribe: 'Batal Berlangganan',
  Back: 'Kembali',
  Chances: 'Kesempatan',
  Setting: 'Pengaturan',
  Menu: 'Menu',
  New: 'Baru',
  image_max_size: "Ukuran berkas melebihi 5MB",
  file_max_size: "Ukuran berkas melebihi 1MB",
  new_chat: "Obrolan Baru",
  file: "Berkas",
  image: "Gambar",
  invalid_image_format: "Format berkas tidak valid",
  Shoot_same_video: "Rekam Video",
  otp_tips: "Silakan masukkan kode OTP",
  style: "gaya",

}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js